var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FEB454",
  d: "m13.223 4.532 7.339 13.863a1 1 0 0 1-.884 1.468H5a1 1 0 0 1-.884-1.468l7.34-13.863a1 1 0 0 1 1.767 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.363 9.863h2.304v1.184l-.42 3.204h-1.452l-.432-3.204zm1.104 5.228q.504 0 .822.312t.318.804q0 .504-.318.822t-.822.318q-.492 0-.81-.318t-.318-.822q0-.492.318-.804t.81-.312"
}))));
export { SvgError as ReactComponent };
export default __webpack_public_path__ + "static/media/error.49ad4448.svg";